import { Location } from "history";
import { match } from "react-router";

export const isActiveItem = ({
  path,
  matchPaths,
  match,
  location,
}: {
  path?: string;
  matchPaths?: string[];
  match?: match<{}> | null;
  location: Location<unknown>;
}) => {
  if (!path) return false;

  // match exact path
  if (match?.isExact) return true;

  // match route with the search and hash
  if (path === `${location.pathname}${location.search}${location.hash}`) return true;

  // match edit routes
  if (location.pathname.includes(`${path}/edit`)) return true;

  // match extra manually defined paths
  return matchPaths?.includes(location.pathname);
};
